import { Options } from 'gif.js.optimized'
import { MediaFrame, MediaSprite } from '../../../types'
import { getGifFromFrames } from './from-frames'
import { getGifFromSprite } from './from-sprite'

export const gifProps: Partial<Options> = {
    workers: 4,
    workerScript: '/static/public/workers/gif.worker.js',
    quality: 8,
    dither: 'FloydSteinberg-serpentine',
}

export function greenScreen(canvas: HTMLCanvasElement) {
    const context = canvas.getContext('2d', { willReadFrequently: true })

    if (context) {
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
        const data = imageData.data

        for (let i = 0; i < data.length; i += 4) {
            if (data[i + 3] < 255) {
                data[i] = 0
                data[i + 1] = 255
                data[i + 2] = 0
                data[i + 3] = 255
            }
        }

        context.putImageData(imageData, 0, 0)
    }
}

function checkIfSticker(canvas: HTMLCanvasElement, frameWidth?: number, frameHeight?: number): boolean {
    const context = canvas.getContext('2d')
    const imageData = context?.getImageData(0, 0, frameWidth || canvas.width, frameHeight || canvas.height)

    if (imageData && imageData.data) {
        const minTransparentPixels = Math.round(imageData.width * imageData.height * 0.2)
        const data = imageData.data
        let transparentPixels = 0

        for (let i = 0; i < data.length; i += 4) {
            const alpha = data[i + 3]
            if (alpha === 0) {
                transparentPixels++

                if (transparentPixels >= minTransparentPixels) {
                    break
                }
            }
        }

        return transparentPixels >= minTransparentPixels
    }

    return false
}

export async function gifFromMediaSprite(sprite: MediaSprite): Promise<File> {
    const isSticker = checkIfSticker(sprite.canvas, sprite.frameWidth, sprite.frameHeight)

    return getGifFromSprite(sprite, isSticker)
}

export async function gifFromMediaFrames(frames: MediaFrame[]): Promise<File> {
    const isSticker = checkIfSticker(frames[0].canvas)

    return getGifFromFrames(frames, isSticker)
}
